import texts from '@components/Calculators/FinancialGoalCorpus/en.json';
import { theme } from '@ui/tailwind.config';

export const financialGoalCorpusDefaultValues = {
    goalAmount: 5000000,
    expectedReturn: 10,
    tenure: 30,
};

export const goalCorpusCalculatorFields = {
    goalAmount: {
        id: 'goalAmount',
        fieldName: texts?.GoalAmount,
        prefix: '₹',
        width: 'w-[107px]',
        sliderInterval: 50000,
        minValue: 100000,
        maxValue: 100000000,
        maxLength: 12,
        shouldFormatValue: true,
        showLimit: true,
        className: 'text-left',
    },
    expectedReturn: {
        id: 'expectedReturn',
        fieldName: texts?.ExpectedReturn,
        suffix: '%',
        width: 'w-10',
        sliderInterval: 1,
        minValue: 1,
        maxValue: 30,
        maxLength: 5,
        showLimit: true,
    },
    tenure: {
        id: 'tenure',
        fieldName: texts?.Tenure,
        suffix: 'years',
        suffixSingular: 'year',
        width: 'w-10',
        sliderInterval: 1,
        minValue: 5,
        maxValue: 40,
        maxLength: 3,
        shouldFormatValue: true,
        showLimit: true,
    },
};

export const getGoalCorpusCalculatorFields = ({
    goalAmount,
    expectedReturn,
    tenure,
}) => {
    return {
        goalAmount: {
            ...goalCorpusCalculatorFields.goalAmount,
            value: goalAmount,
        },
        expectedReturn: {
            ...goalCorpusCalculatorFields.expectedReturn,
            value: expectedReturn,
        },
        tenure: { ...goalCorpusCalculatorFields.tenure, value: tenure },
    };
};

export const financialGoalCorpusType = {
    MARRIAGE_CORPUS: 'marriageCorpus',
    EDUCATION_CORPUS: 'educationCorpus',
};

export const getGoalCorpusCalculatorName = (type) => {
    switch (type) {
        case financialGoalCorpusType.MARRIAGE_CORPUS:
            return texts?.MarriageCorpus;
        default:
            return texts?.EducationCorpus;
    }
};

export const getGoalCorpusPieChartData = (calculatedValue) => [
    {
        name: 'Principal',
        value: calculatedValue.principal,
        color: theme.colors.primary?.[500],
    },
    {
        name: 'Estimated returns',
        value: calculatedValue.estimatedReturns,
        color: theme.colors.primary?.[70],
    },
];
